export const Logo = ({ light = true }) => (
  <span className="leading-none">
    <span className={`block font-serif text-lg tracking-tight ${light ? "text-[#F4F1EA]" : "text-[#241A12]"}`}>
      Plas Llechylched
    </span>
    <span className={`mt-1 block font-mono text-[10px] uppercase tracking-[0.25em] ${light ? "text-[#C89D56]" : "text-[#B85D43]"}`}>
      Rhosneigr · Anglesey
    </span>
  </span>
);

export default Logo;
